import moment from 'moment'
import * as RasaInput from '../../components/rasa-input'
import * as Constants from './constants'
import * as Types from './types'

export const weeksText =  (s: Types.Schedule): string => {
  if (needsWeeks(s.frequency)) {
    switch (s.weeks) {
      case '1': return 'Odd weeks'
      case '2': return 'Even weeks'
      case '3': return 'Third week'
      case '4': return 'Fourth week'
      case '5': return 'Fifth week'
      case '1,3': return '1st and 3rd weeks'
      case '2,4': return '2nd and 4th weeks'
      case '1,2,3,4,5': return 'Every week'
      default: return s.weeks
    }
  } else {
    return ''
  }
}

export const daysText = (s: Types.Schedule): string => {
  if (needsDays(s.frequency)) {
    switch (s.days) {
      case 'MTWRF': return 'Weekdays'
      case 'MTWRFSU': return 'Daily'
      default: return s.days
    }
  } else {
    return ''
  }
}

export const asDropdown = (schedules: Types.ScheduleState): RasaInput.DropdownOption[] => {
  return schedules.filter((s: Types.Schedule) => s.is_active)
                  .map((s: Types.Schedule) => ({key: s.id, description: s.name}))
}
export const toSelected = (s: string, inputs: Types.FrequencyUnit[]): Types.SelectedFrequencyUnit[] => {
  return inputs.map((u: Types.FrequencyUnit) => ({unit: u, isActive: s && s.includes(u.key)}))
}
export const toFrequency =
  (frequency: string, toggled: Types.SelectedFrequencyUnit, inputs: Types.FrequencyUnit[]): string[] => {
    return toSelected(frequency, inputs)
      .map((u: Types.SelectedFrequencyUnit) => u.unit.key === toggled.unit.key ? { ...u, isActive: !u.isActive } : u)
      .filter((u: Types.SelectedFrequencyUnit) => u.isActive)
      .map((u: Types.SelectedFrequencyUnit) => u.unit.key)
}

export const toSelectedDays = (s: string): Types.SelectedFrequencyUnit[] => toSelected(s, Constants.ALL_DAYS)

export const toSelectedWeeks = (s: string, frequency: string): Types.SelectedFrequencyUnit[] => {
  return frequency === Constants.BIWEEKLY.key ?
            toSelected(s, Constants.BIWEEKLY_WEEKS) :
            toSelected(s, Constants.ALL_WEEKS)
}

export const toDaysString = (frequency: string, toggled: Types.SelectedFrequencyUnit): string => {
  return toFrequency(frequency, toggled, Constants.ALL_DAYS).join('')
}
export const toWeeksString = (frequency: string, toggled: Types.SelectedFrequencyUnit): string => {
  return toFrequency(frequency, toggled, Constants.ALL_WEEKS).join(',')
}

export const needsWeeks = (frequency: string): boolean => {
  return frequency === Constants.BIWEEKLY.key || frequency === Constants.MONTHLY.key
}

export const needsDays = (frequency: string): boolean => {
  return frequency !== Constants.DAILY.key
}

export const getTimeFromOffset = (time: string, cutoff: string) =>
 moment(time, 'HH:mm').subtract(cutoff, 'minutes').format('hh:mm')



// WEBPACK FOOTER //
// ./src/pages/schedules/utils.ts